import { Component, OnInit, EventEmitter, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/core/helper/common.service';
import { DataStorage } from 'src/app/core/helper/data.storage';
import { PmdSidebar } from 'src/app/shared/propeller';

@Component({
  selector: 'app-navbar-before-login',
  templateUrl: './before-login-navbar.component.html',
  styleUrls: ['./before-login-navbar.component.scss'],
  host: {
    class:'container-fluid',
  }
})
export class BeforeLoginNavbarComponent implements OnInit {

  @ViewChild(PmdSidebar) leftSidebar ;

  titleObj:any = {};

  localMessage: any = {}

  constructor( private router: Router, 
    private activatedRoute: ActivatedRoute, 
    private commonService : CommonService,
    private dataStorage: DataStorage,
  ) {   
    this.dataStorage.dataStorageMessage.subscribe(message => {
      this.localMessage = { title: message['title'], breadcrumb: message['breadcrumb'], backLink: message['backLink'] }
      this.localMessage = message
    });
  }

  // languageForm: FormGroup;
  language = 'en';
  languages = [
    { id: 'en', name: 'English' },
    { id: 'sp', name: 'Spanish' },
    { id: 'fr', name: 'French' },
    { id: 'ar', name: 'Arabic' },
    { id: 'ru', name: 'Russian'}
  ];

  changeLang(){
    // console.log('===========change language======', this.language)
    this.commonService.changeLanguage(this.language)
  }

  ngOnInit(){

  }

  toggleSideBar(){
    // this.leftSidebar.toggleSideBar();
    this.commonService.sideBarToggle.emit();
  }
 
}
